<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
export default {
  name: 'app',
  data () {
    return {
    }
  }
}
</script>

<style>
body {
  padding-top: 5rem;
}
</style>


// WEBPACK FOOTER //
// App.vue?13a7d3a8